import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";



const PhpLesson8 = () => {
    const [language, changeLanguage] = useState("php");
    const [lineNumbers, toggleLineNumbers] = useState(false);
      const code = (
        'text',
        `
        <?php
         function greet($name){
            echo "Hello"  .$name!;
         }

         echo greet('Lawson');  //Outputs Hello Lawson
         echo greet('Luke'); //Outputs Hello Luke

        ?>

        `
      );
      const code1 = (
        'text',
        `
        <?php
         function greet($x, $y){
            return $x + $y;
         }

         echo sum(5,4);  //Outputs 9
        ?>

        `
      );





  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">


    <div className="alert alert-secondary" role="alert">
    <h3><strong>Functions</strong></h3>

    <p>In programming, a function is a block of code that performs a specific task. Functions are a way to organize and reuse code, and can make your code easier to read,
      understand, and test.</p>
    <p>Functions often accept input in the form of parameters, and may return a result in the form of a return value. They may also modify the state of the program or interact with external resources, such as databases or files.</p>
      <CopyBlock
        language={"php"}
        text={code}
        showLineNumbers={lineNumbers}
        theme={dracula}
        wrapLines={true}
        codeBlock
        />
    <br />
    <p>This function, called <b>greet</b>, takes a single argument called <b>$name</b>. It then prints a greeting message to the screen using the echo function.</p>
    <p>To create a function in PHP, use the <b>function keyword</b>, followed by the name of the function, a list of parameters in parentheses, and a block of code in curly braces.</p>
    <p>You can then call the function by simply using its name, followed by a list of arguments in parentheses.</p>
    <CopyBlock
    language={"php"}
    text={code1}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <br />
    <p>This function, called <b>add</b>, takes two arguments, <b>`$x`</b> and <b>`$y`</b>, and returns their sum.
       The function is called with the arguments 3 and 4, and the result is assigned to the variable <b>`$sum`</b>.</p>
    <p>Functions can be very simple or very complex, and can be used in many different ways depending on the needs of your program.</p>

    </div>

    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default PhpLesson8
